import {
  Utensils,
  Sparkles,
  Heart,
  ShoppingBag,
  GraduationCap,
  Music,
  Laptop,
  Scissors,
  Dumbbell,
  Home,
  Plane,
  Grid2x2,
} from 'lucide-react';
import type { LoginOnboardingSlide } from '../services/types';
import { PARTNER_FILTER_CATEGORIES, normalizePartnerCategory } from './categories';

export {
  PARTNER_CATEGORIES,
  PARTNER_FILTER_CATEGORIES,
  normalizePartnerCategory,
  isOfficialPartnerCategory,
} from './categories';

export const CATEGORIES = [...PARTNER_FILTER_CATEGORIES];
export const CITIES = ['Porto Alegre', 'Caxias do Sul'];

export const DEFAULT_COVER =
  'https://images.unsplash.com/photo-1557672172-298e090bd0f1?auto=format&fit=crop&w=600&q=80';
export const DEFAULT_LOGO = 'https://placehold.co/128x128/0a0a14/ffffff?text=SIX';
export const DEFAULT_CARD_IMAGE =
  'https://images.unsplash.com/photo-1557672172-298e090bd0f1?auto=format&fit=crop&w=600&q=80';
export const DEFAULT_LOGIN_ONBOARDING_SLIDES: LoginOnboardingSlide[] = [
  {
    imageUrl: DEFAULT_CARD_IMAGE,
    title: 'Sua vantagem começa antes da festa.',
    subtitle: 'Benefícios exclusivos para viver melhor a jornada da sua formatura.',
    active: true,
  },
  {
    imageUrl:
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=80',
    title: 'Descontos em lugares que fazem sentido.',
    subtitle: 'Restaurantes, eventos, serviços e experiências selecionadas para formandos.',
    active: true,
  },
  {
    imageUrl:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=900&q=80',
    title: 'Entre e escolha como aproveitar.',
    subtitle: 'Acesse como aluno ou parceiro. A autenticação por telefone entra aqui em breve.',
    active: true,
  },
];

export const CATEGORY_CARDS = [
  {
    id: 'Gastronomia',
    name: 'Gastronomia',
    desc: 'Sushi, Pizza & Mais',
    icon: Utensils,
    colors: 'from-orange-500/20 to-red-600/20 border-orange-500/30 hover:border-orange-500/60',
    iconColor: 'text-orange-400',
    descColor: 'text-orange-200/70',
    glow: 'bg-orange-500/30',
  },
  {
    id: 'Beleza & Estética',
    name: 'Beleza & Estética',
    desc: 'Makes, unhas e autocuidado',
    icon: Sparkles,
    colors: 'from-pink-500/20 to-rose-600/20 border-pink-500/30 hover:border-pink-500/60',
    iconColor: 'text-pink-400',
    descColor: 'text-pink-200/70',
    glow: 'bg-pink-500/30',
  },
  {
    id: 'Saúde & Bem-estar',
    name: 'Saúde & Bem-estar',
    desc: 'Clínicas e bem-estar',
    icon: Heart,
    colors: 'from-emerald-500/20 to-teal-600/20 border-emerald-500/30 hover:border-emerald-500/60',
    iconColor: 'text-emerald-400',
    descColor: 'text-emerald-200/70',
    glow: 'bg-emerald-500/30',
  },
  {
    id: 'Moda & Acessórios',
    name: 'Moda & Acessórios',
    desc: 'Roupas, joias e estilo',
    icon: ShoppingBag,
    colors: 'from-fuchsia-500/20 to-pink-600/20 border-fuchsia-500/30 hover:border-fuchsia-500/60',
    iconColor: 'text-fuchsia-400',
    descColor: 'text-fuchsia-200/70',
    glow: 'bg-fuchsia-500/30',
  },
  {
    id: 'Educação',
    name: 'Educação',
    desc: 'Cursos e preparo',
    icon: GraduationCap,
    colors: 'from-green-500/20 to-emerald-600/20 border-green-500/30 hover:border-green-500/60',
    iconColor: 'text-green-400',
    descColor: 'text-green-200/70',
    glow: 'bg-green-500/30',
  },
  {
    id: 'Entretenimento',
    name: 'Entretenimento',
    desc: 'Festas, bares e experiências',
    icon: Music,
    colors: 'from-blue-500/20 to-indigo-600/20 border-blue-500/30 hover:border-blue-500/60',
    iconColor: 'text-blue-400',
    descColor: 'text-blue-200/70',
    glow: 'bg-blue-500/30',
  },
  {
    id: 'Tecnologia',
    name: 'Tecnologia',
    desc: 'Tech e soluções digitais',
    icon: Laptop,
    colors: 'from-cyan-500/20 to-sky-600/20 border-cyan-500/30 hover:border-cyan-500/60',
    iconColor: 'text-cyan-400',
    descColor: 'text-cyan-200/70',
    glow: 'bg-cyan-500/30',
  },
  {
    id: 'Serviços',
    name: 'Serviços',
    desc: 'Soluções para o dia a dia',
    icon: Scissors,
    colors: 'from-purple-500/20 to-fuchsia-600/20 border-purple-500/30 hover:border-purple-500/60',
    iconColor: 'text-purple-400',
    descColor: 'text-purple-200/70',
    glow: 'bg-purple-500/30',
  },
  {
    id: 'Esporte & Fitness',
    name: 'Esporte & Fitness',
    desc: 'Treino e movimento',
    icon: Dumbbell,
    colors: 'from-lime-500/20 to-green-600/20 border-lime-500/30 hover:border-lime-500/60',
    iconColor: 'text-lime-400',
    descColor: 'text-lime-200/70',
    glow: 'bg-lime-500/30',
  },
  {
    id: 'Casa & Decoração',
    name: 'Casa & Decoração',
    desc: 'Ambientes e detalhes',
    icon: Home,
    colors: 'from-amber-500/20 to-orange-600/20 border-amber-500/30 hover:border-amber-500/60',
    iconColor: 'text-amber-400',
    descColor: 'text-amber-200/70',
    glow: 'bg-amber-500/30',
  },
  {
    id: 'Viagem & Turismo',
    name: 'Viagem & Turismo',
    desc: 'Destinos e passagens',
    icon: Plane,
    colors: 'from-sky-500/20 to-blue-600/20 border-sky-500/30 hover:border-sky-500/60',
    iconColor: 'text-sky-400',
    descColor: 'text-sky-200/70',
    glow: 'bg-sky-500/30',
  },
  {
    id: 'Outros',
    name: 'Outros',
    desc: 'Mais beneficios e parceiros',
    icon: Grid2x2,
    colors: 'from-slate-500/20 to-slate-700/20 border-slate-500/30 hover:border-slate-500/60',
    iconColor: 'text-slate-300',
    descColor: 'text-slate-300/70',
    glow: 'bg-slate-400/20',
  },
];

const RAW_INITIAL_PARTNERS = [
  // PORTO ALEGRE
  {
    id: 1,
    name: 'Guacamole Taqueria',
    category: 'Gastronomia',
    discount: '10% OFF na comanda',
    address: 'R. Des. Augusto Loureiro Lima, 165 - POA',
    description: 'A melhor comida mexicana de POA.',
    rules: '10% de desconto no fechamento da comanda. Apresente seu Six Pass válido.',
    icon: '🌮',
    logoUrl: 'https://ui-avatars.com/api/?name=G+T&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1565299507177-b0ac66763828?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: true,
    instagram: 'guacamolepoa',
    usageCount: 142,
    city: 'Porto Alegre',
  },
  {
    id: 2,
    name: 'Drago Sushi',
    category: 'Gastronomia',
    discount: '15% OFF',
    address: 'Av. Érico Veríssimo, 472 - POA',
    description: 'O melhor sushi da Zona Sul.',
    rules: '15% de desconto. Consulte condições no local ao apresentar o cartão.',
    icon: '🍣',
    logoUrl: 'https://ui-avatars.com/api/?name=D+S&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: true,
    instagram: 'dragosushi',
    usageCount: 89,
    city: 'Porto Alegre',
  },
  {
    id: 3,
    name: 'Auma Bar',
    category: 'Eventos',
    discount: 'Entrada FREE',
    address: 'R. Alm. Barroso, 304 - POA',
    description: 'O bar mais underground do 4º Distrito.',
    rules: 'Entrada free independente do horário mediante apresentação do Six Pass.',
    icon: '🍹',
    logoUrl: 'https://ui-avatars.com/api/?name=A+B&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: false,
    instagram: 'aumabar',
    usageCount: 215,
    city: 'Porto Alegre',
  },
  {
    id: 4,
    name: 'Conceito Vestibular',
    category: 'Educação',
    discount: '30% OFF',
    address: 'Av. Independência, 702 - POA',
    description: 'Cursos e pré-vestibular.',
    rules: '30% de desconto no pré-vestibular em todas as modalidades.',
    icon: '📚',
    logoUrl: 'https://ui-avatars.com/api/?name=C+V&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: false,
    instagram: 'conceitovestibular',
    usageCount: 45,
    city: 'Porto Alegre',
  },
  {
    id: 5,
    name: 'Olha Ela',
    category: 'Vestuário',
    discount: '10% OFF',
    address: 'R. Dona Rafaela, 224 - Canoas',
    description: 'Aluguel de vestidos.',
    rules: '10% de desconto no aluguel de qualquer vestuário.',
    icon: '👗',
    logoUrl: 'https://ui-avatars.com/api/?name=O+E&background=ff8800&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'olhaela',
    usageCount: 67,
    city: 'Porto Alegre',
  },
  {
    id: 11,
    name: 'Rayo Eventos',
    category: 'Eventos',
    discount: 'Até 30% OFF',
    address: 'Diversos',
    description: 'Links com descontos em diversas festas e eventos.',
    rules: '20% a 30% de desconto nos ingressos + possibilidade de upgrade.',
    icon: '⚡',
    logoUrl: 'https://ui-avatars.com/api/?name=R+E&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'rayoeventos',
    usageCount: 310,
    city: 'Porto Alegre',
  },

  // CAXIAS DO SUL
  {
    id: 101,
    name: 'All Universe',
    category: 'Vestuário',
    discount: '10% OFF',
    address: 'Av. Therezinha P. Sanvitto, 208 - Caxias',
    description: 'Locação de vestidos e trajes masculinos.',
    rules: '10% na locação de vestidos e trajes masculinos.',
    icon: '👗',
    logoUrl: 'https://ui-avatars.com/api/?name=A+U&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1595954421408-72439bc0750a?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: false,
    instagram: 'alluniverse',
    usageCount: 45,
    city: 'Caxias do Sul',
  },
  {
    id: 102,
    name: "Rose's Noivas",
    category: 'Vestuário',
    discount: '10% OFF',
    address: 'Av. Júlio de Castilhos, 542 - Caxias',
    description: 'Trajes para festas, formaturas e debutantes.',
    rules: '10% na locação de trajes.',
    icon: '✨',
    logoUrl: 'https://ui-avatars.com/api/?name=R+N&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'rosesnoivas',
    usageCount: 112,
    city: 'Caxias do Sul',
  },
  {
    id: 103,
    name: 'Gold Roupas',
    category: 'Vestuário',
    discount: 'Consulte',
    address: 'Rua Sinimbu, 2321 (Camelódromo) - Caxias',
    description: 'Roupas variadas.',
    rules: 'Descontos Variáveis, consulte.',
    icon: '👕',
    logoUrl: 'https://ui-avatars.com/api/?name=G+R&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'goldroupas',
    usageCount: 30,
    city: 'Caxias do Sul',
  },
  {
    id: 104,
    name: 'Bello Costume',
    category: 'Vestuário',
    discount: '8% OFF',
    address: 'Rua Do Guia Lopes, 645 - Caxias',
    description: 'Noivas e festas.',
    rules: '8% na locação de vestidos e trajes masculinos.',
    icon: '👔',
    logoUrl: 'https://ui-avatars.com/api/?name=B+C&background=ff5e00&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'bellocostume',
    usageCount: 22,
    city: 'Caxias do Sul',
  },
  {
    id: 105,
    name: 'OKAI Sushi',
    category: 'Gastronomia',
    discount: 'Ganhe Drink',
    address: 'Rua Olavo Bilac, 503 - Caxias',
    description: 'Sushi Premium.',
    rules: 'Na compra de 1 item do cardápio, ganhe 1 drink.',
    icon: '🍣',
    logoUrl: 'https://ui-avatars.com/api/?name=O+S&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: true,
    instagram: 'okaisushi',
    usageCount: 150,
    city: 'Caxias do Sul',
  },
  {
    id: 106,
    name: 'La Brasa Burger',
    category: 'Gastronomia',
    discount: '10% OFF',
    address: 'Rua Olavo Bilac, 503 - Pátio da Estação',
    description: 'Hambúrgueres artesanais.',
    rules: '10% em hambúrgueres.',
    icon: '🍔',
    logoUrl: 'https://ui-avatars.com/api/?name=L+B&background=ff5e00&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'labrasaburger',
    usageCount: 205,
    city: 'Caxias do Sul',
  },
  {
    id: 107,
    name: 'Hamburguer & Cia',
    category: 'Gastronomia',
    discount: '10% OFF',
    address: 'R. Sinimbu, 815 - Caxias',
    description: 'Lanches deliciosos.',
    rules: '10% em lanches.',
    icon: '🍔',
    logoUrl: 'https://ui-avatars.com/api/?name=H+C&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'hamburguerecia',
    usageCount: 78,
    city: 'Caxias do Sul',
  },
  {
    id: 108,
    name: 'GF Store',
    category: 'Vestuário',
    discount: 'Até 10% OFF',
    address: 'R. Pinheiro Machado, 2486 - Caxias',
    description: 'Moda e acessórios.',
    rules: '10% no Dinheiro/Pix ou 5% a Prazo.',
    icon: '🛍️',
    logoUrl: 'https://ui-avatars.com/api/?name=G+F&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'gfstore',
    usageCount: 65,
    city: 'Caxias do Sul',
  },
  {
    id: 109,
    name: 'Don Manera Barbiere',
    category: 'Serviços',
    discount: '20% OFF',
    address: 'Rua Dr. Montaury, 660 - Caxias',
    description: 'Barbearia clássica.',
    rules: '20% de Seg a Quinta em Cabelo ou Barba.',
    icon: '✂️',
    logoUrl: 'https://ui-avatars.com/api/?name=D+M&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: false,
    instagram: 'donmanera',
    usageCount: 130,
    city: 'Caxias do Sul',
  },
  {
    id: 110,
    name: 'Toke Final Makes',
    category: 'Vestuário',
    discount: '7% OFF',
    address: 'R. Visconde de Pelotas, 705 - Caxias',
    description: 'Makes e acessórios.',
    rules: '7% em qualquer item.',
    icon: '💄',
    logoUrl: 'https://ui-avatars.com/api/?name=T+F&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1512496115851-a408e8b03431?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'tokefinal',
    usageCount: 95,
    city: 'Caxias do Sul',
  },
  {
    id: 111,
    name: 'La Mafia Platas',
    category: 'Vestuário',
    discount: '15% OFF',
    address: 'R. Pinheiro Machado, 1922 - Caxias',
    description: 'Joias em prata.',
    rules: '15% em qualquer peça.',
    icon: '💍',
    logoUrl: 'https://ui-avatars.com/api/?name=L+M&background=5e00ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'lamafiaplatas',
    usageCount: 42,
    city: 'Caxias do Sul',
  },
  {
    id: 112,
    name: 'Eleganza Acessórios',
    category: 'Vestuário',
    discount: '12% OFF',
    address: 'Av. Júlio de Castilhos, 2700 - Caxias',
    description: 'Semijoias finas.',
    rules: '12% em semijoias.',
    icon: '💎',
    logoUrl: 'https://ui-avatars.com/api/?name=E+A&background=ff5e00&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'eleganza',
    usageCount: 38,
    city: 'Caxias do Sul',
  },
  {
    id: 113,
    name: 'Emilly Victoria Lash',
    category: 'Serviços',
    discount: '15% OFF',
    address: 'R. Pinheiro Machado, 1922 - Caxias',
    description: 'Lash Designer.',
    rules: '15% na extensão de cílios.',
    icon: '👁️',
    logoUrl: 'https://ui-avatars.com/api/?name=E+V&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1587931899575-3b9599fbfa62?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'emillyvictoria',
    usageCount: 105,
    city: 'Caxias do Sul',
  },
  {
    id: 114,
    name: 'Will Santos Hair',
    category: 'Serviços',
    discount: '10% OFF',
    address: 'R. Os 18 Do Forte, 848 - Caxias',
    description: 'Penteados incríveis.',
    rules: '10% em Penteados.',
    icon: '💇‍♀️',
    logoUrl: 'https://ui-avatars.com/api/?name=W+S&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1562322140-8baeececf3df?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'willsantoshair',
    usageCount: 52,
    city: 'Caxias do Sul',
  },
  {
    id: 115,
    name: 'Thaila Masiero Nails',
    category: 'Serviços',
    discount: 'Até 10% OFF',
    address: 'R. Guerino Sanvitto, 950 - Caxias',
    description: 'Nail Designer.',
    rules: '10% Esmaltação em Gel/Tradicional e Blindagem.',
    icon: '💅',
    logoUrl: 'https://ui-avatars.com/api/?name=T+M&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'thailamasiero',
    usageCount: 68,
    city: 'Caxias do Sul',
  },
  {
    id: 116,
    name: 'Tata Bronzeamentos',
    category: 'Serviços',
    discount: '25% OFF',
    address: 'Visconde De Pelotas, 2319 - Caxias',
    description: 'Bronzeamento perfeito.',
    rules: '25% em Pacotes.',
    icon: '☀️',
    logoUrl: 'https://ui-avatars.com/api/?name=T+B&background=ff8800&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: true,
    instagram: 'tatabronze',
    usageCount: 145,
    city: 'Caxias do Sul',
  },
  {
    id: 117,
    name: 'Studio Brenda Fontana',
    category: 'Serviços',
    discount: 'Até 15% OFF',
    address: 'R. Pinheiro Machado, 1922 - Caxias',
    description: 'Unhas e alongamentos.',
    rules: '15% Alongamento em Acrílico, 10% Blindagem e Gel.',
    icon: '💅',
    logoUrl: 'https://ui-avatars.com/api/?name=S+B&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1519014816548-bf5fe059e98b?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'brendafontana',
    usageCount: 40,
    city: 'Caxias do Sul',
  },
  {
    id: 118,
    name: 'MS Beauty Academy',
    category: 'Serviços',
    discount: '10% OFF',
    address: 'Av Itália, 277 - Caxias',
    description: 'Beauty Academy.',
    rules: '10% Na Extensão De Cílios.',
    icon: '👁️',
    logoUrl: 'https://ui-avatars.com/api/?name=M+S&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1512496115851-a408e8b03431?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'msbeauty',
    usageCount: 33,
    city: 'Caxias do Sul',
  },
  {
    id: 119,
    name: 'Luane Toledo Makeup',
    category: 'Serviços',
    discount: '10% OFF',
    address: 'Rua João Batista Bampi, 49 - Caxias',
    description: 'Maquiagem profissional.',
    rules: '10% em Maquiagem.',
    icon: '💄',
    logoUrl: 'https://ui-avatars.com/api/?name=L+T&background=ff5e00&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: true,
    instagram: 'luanetoledo',
    usageCount: 88,
    city: 'Caxias do Sul',
  },
  {
    id: 120,
    name: 'Daiana Forneck',
    category: 'Serviços',
    discount: 'Consulte',
    address: 'Atendimento A Domicílio',
    description: 'Beleza em casa.',
    rules: 'Atendimento A Domicílio, consulte vantagens.',
    icon: '🏡',
    logoUrl: 'https://ui-avatars.com/api/?name=D+F&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'daianaforneck',
    usageCount: 15,
    city: 'Caxias do Sul',
  },
  {
    id: 121,
    name: 'Gold Tênis',
    category: 'Vestuário',
    discount: 'Descontos Variáveis',
    address: 'R. Sinimbu, 2321 - Caxias',
    description: 'Sneakers e calçados.',
    rules: 'Consulte os descontos na loja.',
    icon: '👟',
    logoUrl: 'https://ui-avatars.com/api/?name=G+T&background=5e00ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: true,
    instagram: 'goldtenis',
    usageCount: 220,
    city: 'Caxias do Sul',
  },
  {
    id: 122,
    name: 'Dr. Tiago Tedesco',
    category: 'Serviços',
    discount: '15% OFF',
    address: 'R. Pinheiro Machado, 1922 - Caxias',
    description: 'Odontologia e Harmonização.',
    rules: '15% Clareamento, Botox, Rinomodelação E Preenchimento.',
    icon: '👨‍⚕️',
    logoUrl: 'https://ui-avatars.com/api/?name=T+T&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'drtiagotedesco',
    usageCount: 25,
    city: 'Caxias do Sul',
  },
  {
    id: 123,
    name: 'Orthodontic',
    category: 'Serviços',
    discount: '10% OFF',
    address: 'Rua Pinheiro Machado, 1922 - Caxias',
    description: 'Clínica Odontológica.',
    rules: '10% Em Limpezas, Clareamento E Restaurações.',
    icon: '🦷',
    logoUrl: 'https://ui-avatars.com/api/?name=O+T&background=ff007f&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'orthodontic',
    usageCount: 48,
    city: 'Caxias do Sul',
  },
  {
    id: 124,
    name: 'Lótus Restaurante',
    category: 'Gastronomia',
    discount: '10% OFF',
    address: 'R. Moreira César, 3013 - Caxias',
    description: 'Comida deliciosa.',
    rules: '10% de desconto.',
    icon: '🍽️',
    logoUrl: 'https://ui-avatars.com/api/?name=L+R&background=84ff00&color=000&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'lotusrestaurante',
    usageCount: 60,
    city: 'Caxias do Sul',
  },
  {
    id: 125,
    name: 'Sky Plus',
    category: 'Serviços',
    discount: '15% OFF',
    address: 'Online / Telefone',
    description: 'Passagens Aéreas.',
    rules: '15% em passagens aéreas nacionais e internacionais.',
    icon: '✈️',
    logoUrl: 'https://ui-avatars.com/api/?name=S+P&background=00a2ff&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=600&q=80',
    highlight: true,
    trending: true,
    instagram: 'skyplus',
    usageCount: 190,
    city: 'Caxias do Sul',
  },
  {
    id: 126,
    name: 'Loja ZNT',
    category: 'Vestuário',
    discount: '10% OFF',
    address: 'Rua Visconde de Pelotas, 909 - Caxias',
    description: 'Loja de roupas e acessórios.',
    rules: '10% de desconto.',
    icon: '👕',
    logoUrl: 'https://ui-avatars.com/api/?name=Z+N&background=ff5e00&color=fff&size=128',
    coverUrl:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=600&q=80',
    highlight: false,
    trending: false,
    instagram: 'lojaznt',
    usageCount: 75,
    city: 'Caxias do Sul',
  },
];

export const INITIAL_PARTNERS = RAW_INITIAL_PARTNERS.map((partner) => ({
  ...partner,
  category: normalizePartnerCategory(partner.category),
}));
